import { ActionTree } from 'vuex'
import { StakeholderState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<StakeholderState, RootState> = {
}
